
const ValueBox = ({img,title,text,option1,option2,name1,name2}) => {
    return(
        <div
        className='flex gap-4 -mt-3 lg:mt-0'>
            
            <div
            className="w-[60px] h-[60px] lg:w-[75px] lg:h-[75px]
             bg-aqua rotate-12 rounded-[20px] lg:rounded-[30px] flex
             justify-center">
                <img
                src={img}
                className='w-[25px] lg:w-[30px] object-contain -rotate-12'
                />
            </div>
            
            <div className='w-9/12 flex flex-col'>
            <h4 className='font-medium'>
                {title}
            </h4>
            <p className='text-[#707070] text-[13.4px] lg:text-[15px] flex flex-col'>
                <span>
                    {text}
                </span>
                <span className="flex justify-between">
                    <span>
                        {name1}
                    </span>
                    <span> 
                    {option1}
                </span>
                
                </span>
                <span className="flex justify-between">
                    <span>
                        {name2}
                    </span>
                    <span>
                    {option2}
                </span>
                </span>
            </p>
            </div>
        </div>
    )
}
export default ValueBox